var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHistory = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.52 5.264a5.25 5.25 0 0 0 .73 6.41V10.5a.75.75 0 0 1 1.5 0v3a.75.75 0 0 1-.75.75H2a.75.75 0 0 1 0-1.5h1.204a6.75 6.75 0 1 1 7.34 1.502.75.75 0 1 1-.565-1.389 5.251 5.251 0 1 0-6.46-7.599z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 4.75a.75.75 0 0 1 .75.75v2.19l1.78 1.78a.75.75 0 1 1-1.06 1.06l-2-2A.75.75 0 0 1 7.25 8V5.5A.75.75 0 0 1 8 4.75"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHistory);
export default ForwardRef;